class IdentityPopover extends HTMLElement {

  static get CONSTANT_CONTENT_CLASSNAME() { return 'identity-popover-content' };
  static get CONSTANT_CONTENT_ALIGN_RIGHT_CLASSNAME() { return 'align-right' };
  static get CONSTANT_CONTENT_ALIGN_TOP_CLASSNAME() { return 'align-top' };
  static get CONSTANT_REMOTE_CONTENT_CLASS_PATH() { return '.js-e-content .e-content-article > .e-section > .container-fluid > .row > .col-12 > .row' };
  
  static get observedAttributes() {
    return ['show'];
  }

  get show() {
    return this.getAttribute( 'show' );
  }

  set show( val ) {
    this.setAttribute( 'show', val );
  }
  
  constructor() {
    super();
    this.contentUrl = this.getAttribute('content-url');
    const template = this.querySelector('template');
    if(template !== null){
      this.template = template.content;
    }

    document.body.addEventListener('click', (event) =>{
      if(event.target !== this){
        this.show = false;
      }
    }, false);
  }

  connectedCallback() {
    this.addEventListener('click', this, false);
    this.addEventListener('mouseenter', this, false);
    this.addEventListener('mouseleave', this, false);
  }
  
  handleEvent(event){
    switch ( event.type ){
      case 'click':
        this.show = !this.parseBool(this.show);
        break;
      case 'mouseenter':
        this.show = true;
        break;
      case 'mouseleave':
        this.show = false;
        break;
    }
  }

  attributeChangedCallback( name, oldValue, newValue ) {
    if (oldValue === null || oldValue === newValue) return;
    if(name === 'show'){
      this.toggle(newValue);
    }
  }

  getCumulativeOffset(element){
    var top = 0, left = 0;
    do {
      top += element.offsetTop  || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while(element);

    return {
      top: top,
      left: left
    };
  }
  toggle(boolShow){
    let popoverContent = this.querySelector(`.${IdentityPopover.CONSTANT_CONTENT_CLASSNAME }`);
    if(this.parseBool(boolShow)){
      if(popoverContent === null){
        if(this.template !== undefined){
          popoverContent = this.getTemplateContent();
          this.appendChild(popoverContent);
          this.alignContent(popoverContent);
        }
        else if(this.contentUrl !== null){
          this.getRemoteContent().then((textHtml) =>{
            popoverContent = this.buildRemoteContent(textHtml);
            this.appendChild(popoverContent);
            this.alignContent(popoverContent);
          });
        }
        
      } else{
        this.alignContent(popoverContent);
      }
    }
  }

  getTemplateContent(){
    const popoverContent = document.createElement('div');
    popoverContent.className = IdentityPopover.CONSTANT_CONTENT_CLASSNAME;
    popoverContent.role = 'tooltip';
    const content = this.template.cloneNode(true);
    popoverContent.appendChild(content);
    return popoverContent;
  }
  getRemoteContent(){
    return fetch(this.contentUrl).then( resp => resp.text());
  }
  buildRemoteContent(textHtml){
    const domParser = new DOMParser();
    const parsedHtml = domParser.parseFromString(textHtml, 'text/html');
    const contentToRender = parsedHtml.querySelector(IdentityPopover.CONSTANT_REMOTE_CONTENT_CLASS_PATH).cloneNode(true);
    const popoverContent = document.createElement('div');
    popoverContent.className = IdentityPopover.CONSTANT_CONTENT_CLASSNAME;
    popoverContent.role = 'tooltip';
    popoverContent.appendChild(contentToRender);
    return popoverContent;
  }
  
  alignContent(popoverContent) {
    //console.log(this.getBoundingClientRect());
    const cumulativeOffset = this.getCumulativeOffset( this );
    if ( cumulativeOffset.left > window.innerWidth / 2 ) {
      popoverContent.classList.add( IdentityPopover.CONSTANT_CONTENT_ALIGN_RIGHT_CLASSNAME );
    }
    if ( cumulativeOffset.top > window.innerHeight ) {
      popoverContent.classList.add( IdentityPopover.CONSTANT_CONTENT_ALIGN_TOP_CLASSNAME );
    }
  }
  
  parseBool(boolStr){
    return boolStr === 'true';
  }
}

customElements.define( 'identity-popover', IdentityPopover );